import { useCreateStore } from '@/entities/create';
import { Login } from '@/features/auth';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { CreateExitPopup } from '@/widgets/modal/ui/created-exit-popup';
import { Link, useRouter } from '@tanstack/react-router';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface HeaderProps {
    children: ReactNode;
}

const Header_type3: FC<HeaderProps> = ({ children }) => {
    const location = useRouter();
    const { setState: createSetState, type } = useCreateStore();
    const { showModal } = useModalStore();
    const showExitPopup = (routeUrl: string) => {
        showModal({
            isCustom: true,
            id: 'create_exit_popup',
            initContents: () => <CreateExitPopup routeUrl={routeUrl} />,
        });
    };

    return (
        <div className="ki-main-header ttukttak type2_header">
            <div className="new-header">
                <div className="new-header-wrap gnb type2_gnb">
                    <div className="gnb_menu flex_b">
                        <div className="logo">
                            <Link to="/create" rel="noreferrer" />
                            <span className="blind">AI 스마트 평가</span>
                        </div>
                        {children}
                        <div style={{ display: 'none' }}>
                            <Login></Login>
                        </div>
                    </div>
                    {type !== 'editMode' && (
                        <div className="tabMenu top_tabMenu import_menu">
                            <ul className="flex_c">
                                <li
                                    key={'tabMenu-0'}
                                    className={clsx({
                                        on: type === 'data',
                                    })}
                                >
                                    <a
                                        onClick={() => {
                                            if (
                                                type === 'SelfCreateMode' ||
                                                type === 'AutoCreateMode'
                                            ) {
                                                showExitPopup('data');
                                            } else {
                                                createSetState('type', 'data');
                                            }
                                        }}
                                    >
                                        평가지 검색
                                    </a>
                                </li>
                                <li
                                    key={'tabMenu-1'}
                                    className={clsx({
                                        on: type !== 'data',
                                    })}
                                >
                                    <a
                                        onClick={() => {
                                            createSetState('type', 'setMode');
                                        }}
                                    >
                                        문항 검색
                                    </a>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header_type3;
